import { z } from 'zod';
export const uuid = z.string().uuid();
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');
export const isoDateTime = z.string().datetime({ offset: true });
export const isoDateOrDateTime = z.union([isoDate, isoDateTime]);
export const phone = z
    .string()
    .min(8)
    .max(20)
    .refine((v) => /^[\d\s+()-]+$/.test(v), 'Invalid phone format');
export const email = z.string().email();
export const optionalEmail = z.string().email().nullable().optional().or(z.literal(''));
export const url = z.string().url();
export const paginationQuery = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(200).default(50),
    sort: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});
//# sourceMappingURL=common.js.map